var app = angular.module("leonardo");

var LevelsFormController = function($scope, $state, parentObj, levelObj, countryObj, LevelService, FormErrorsService) {

  $scope.data = levelObj;
  $scope.countryObj = countryObj;
  $scope.parentObj = parentObj;
  $scope.levelService = LevelService;
  $scope.action = $state.current.action;

  if ($scope.action !== 'edit') {
    $scope.data.parents = $scope.parentObj ? [$scope.parentObj.id] : [];
    $scope.data.country = $scope.countryObj ? $scope.countryObj.id : null;
    $scope.data.level_type = $scope.parentObj ?  $scope.parentObj.level_type + ( $scope.parentObj.level_type == 1 && $scope.countryObj.code.toLowerCase() == "ca" ? 2 : 1) : 1;
  }

  $scope.filtersParents = {
    country: $scope.countryObj.id,
    level_type: $scope.parentObj ? $scope.parentObj.level_type : 1,
    parents: ($scope.parentObj && !isEmpty($scope.parentObj.parents)) ? $scope.parentObj.parents.join(',') : undefined,
  };

  $scope.getLabelParent = function (plural) {
    var level_type = $scope.parentObj ? $scope.parentObj.level_type : 1;
    var label_type = 'level_' + level_type + '_label';
    var result = $scope.countryObj[label_type];
    if (plural) {
      result += 's';
    }
    return result;
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = angular.copy($scope.data);
    if ($scope.action === 'edit'){
      $scope.data.patch(data).then(function(){
        $state.go('countries.levels', {country: $scope.countryObj.id, parent: $scope.parentObj ? $scope.parentObj.id : null});
      });
    }
    else {
      LevelService.post(data).then(function(result) {
        LevelService.updateCollection(result);
        $state.go('countries.levels', {country: $scope.countryObj.id, parent: $scope.parentObj ? $scope.parentObj.id : null});
      });
    }
  };
};

app.controller('LevelsFormController', ['$scope', '$state', 'parentObj', 'levelObj', 'countryObj', 'LevelService', 'FormErrorsService',
  LevelsFormController]);
